import React from 'react';
import { Box, Stack } from '@mui/material';
import { ChannelIcon } from '../../../../components/channel';
import { ChannelType } from '../../../../types/channel';

type ChannelDetailsSensorProps = {
  channel: ChannelType;
  children: React.ReactNode;
};

export const SensorDetailsItem: React.FC<ChannelDetailsSensorProps> = ({ channel, children }) => (
  <Stack
    direction="row"
    alignItems="center"
    maxWidth={600}
    borderRadius={4}
    minHeight={72}
    boxSizing="border-box"
    padding={2}
    sx={{
      backgroundColor: 'var(--color-element)',
    }}
  >
    <Box
      height={24}
      width={24}
      marginRight={2}
      sx={{
        '& svg': {
          height: 24,

          '& [stroke]': {
            stroke: 'var(--color-accent)',
          },
          '& [fill]': {
            fill: 'var(--color-accent)',
          },
        },
      }}
    >
      <ChannelIcon channel={channel} />
    </Box>
    {children}
  </Stack>
);
